import Button from '../atoms/Button';
import css from './QuickCard.module.scss';

export default function QuickCard({ iconName, title, badgeCount, buttonProps, button2Props }) {
  return (
    <div className={css.card}>
      {
        <div className={css['icon-box']}>
          <i className={`fad fa-${iconName} ${css.icon}`} />
          {badgeCount > 0 && <span className={css.badge}>{badgeCount}</span>}
        </div>
      }
      <h4 className={css.title}>{title}</h4>
      <div className={css.buttons}>
        {buttonProps && <Button {...buttonProps} color="gray" variant="secondary" />}
        {button2Props && <Button {...button2Props} />}
      </div>
    </div>
  );
}
